import React from 'react';
import { MailIcon, AlertTriangleIcon } from 'lucide-react';
export function LetterToMembers() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1405">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-10" data-id="element-1406">
        <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
        borderColor: '#ede9e0'
      }} data-id="element-1407">
          <div className="p-4 flex items-center gap-3" style={{
          backgroundColor: '#1e3d2f'
        }} data-id="element-1408">
            <MailIcon size={20} style={{
            color: '#c8a84b'
          }} data-id="element-1409" />
            <h2 className="text-base font-bold uppercase" style={{
            fontFamily: 'Oswald, sans-serif',
            color: '#ffffff'
          }} data-id="element-1410">
              Letter to Members
            </h2>
          </div>
          <div className="p-6 md:p-8" data-id="element-1411">
            <p className="text-sm text-gray-500 mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1412">
              January 5, 2026
            </p>
            <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1413">
              Happy New Year Members!
            </p>
            <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1414">
              As the new year begins, our annual election will take place on
              January 27, 2026 at 7pm at the FLSC clubhouse hall. This meeting
              is a wonderful way to introduce yourself to new and not so new
              members as well as casting your vote for the upcoming slots for
              officers and directors of FLSC. Should you <strong data-id="element-1415">NOT</strong> be
              able to attend, an absentee ballot is attached for you to cast
              your vote and be heard.
            </p>

            {/* Absentee Ballot Rules */}
            <div className="rounded-lg p-5 mb-5" style={{
            backgroundColor: 'rgba(30,61,47,0.04)'
          }} data-id="element-1416">
              <h3 className="text-base font-bold uppercase mb-3" style={{
              fontFamily: 'Oswald, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1417">
                For Absentee Ballots:
              </h3>
              <ol className="space-y-2 ml-1" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1418">
                <li className="flex items-start gap-3" data-id="element-1419">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1420">
                    1
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1421">
                    <em data-id="element-1422">
                      <strong data-id="element-1423">
                        Member status must be in good standing with renewals and
                        dues paid through January 27, 2026.
                      </strong>
                    </em>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1424">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1425">
                    2
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1426">
                    <em data-id="element-1427">
                      <strong data-id="element-1428">
                        Absentee ballots must be received no later than January
                        27, 2026 to FLSC, 1140 Butcher Rd, Fenton, MI
                        48430-1232.
                      </strong>
                    </em>
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1429">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1430">
                    3
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1431">
                    <em data-id="element-1432">
                      <strong data-id="element-1433">
                        Ballots may be dropped off at designated mail slot in
                        the entryway of the Clubhouse (door to cloak room will
                        have sign).
                      </strong>
                    </em>
                  </span>
                </li>
              </ol>
            </div>

            {/* Important Warning */}
            <div className="flex items-start gap-4 p-4 rounded-lg border-2 mb-5" style={{
            backgroundColor: '#fffbeb',
            borderColor: '#c8a84b'
          }} data-id="element-1434">
              <AlertTriangleIcon size={22} className="flex-shrink-0 mt-0.5" style={{
              color: '#c8a84b'
            }} data-id="element-1435" />
              <p className="text-base font-semibold" style={{
              color: '#1e3d2f',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1436">
                Please note: Absentee ballots received after January 27, 2026
                will not be counted and will be destroyed.
              </p>
            </div>

            <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1437">
              **Absentee ballots are available in the entryway of Clubhouse on
              speaker stand.
            </p>

            {/* Absentee Ballot Instructions */}
            <div className="rounded-lg p-5 mb-5" style={{
            backgroundColor: 'rgba(30,61,47,0.04)'
          }} data-id="element-1438">
              <h3 className="text-base font-bold mb-3" style={{
              fontFamily: 'Inter, sans-serif',
              color: '#1e3d2f'
            }} data-id="element-1439">
                For your vote to count, please submit your absentee ballot using
                the following instructions:
              </h3>
              <ol className="space-y-3 ml-1" style={{
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1440">
                <li className="flex items-start gap-3" data-id="element-1441">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1442">
                    1
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1443">
                    After voting, the member shall place his/her ballot in a
                    sealed envelope, with his/her own name and address on the
                    outside.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1444">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1445">
                    2
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1446">
                    This envelope may be mailed inside another envelope or may
                    be taken to the clubhouse prior to the election. *See above
                    for drop off location.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-1447">
                  <span className="w-6 h-6 rounded flex items-center justify-center flex-shrink-0 mt-0.5 text-xs font-bold" style={{
                  backgroundColor: 'rgba(30,61,47,0.08)',
                  color: '#1e3d2f',
                  fontFamily: 'Oswald, sans-serif'
                }} data-id="element-1448">
                    3
                  </span>
                  <span className="text-base text-gray-800" data-id="element-1449">
                    At the election, this envelope shall be checked with the
                    membership list. If the member arrives at this meeting,
                    prior to verification, then this absentee ballot will be
                    voided, and the member may vote.
                  </span>
                </li>
              </ol>
            </div>

            <p className="text-base text-gray-800 leading-relaxed mb-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1450">
              Hope to see you there on{' '}
              <strong data-id="element-1451">
                <u data-id="element-1452">Tuesday, January 27, 2026, 7pm at the FLSC Hall</u>
              </strong>
              !
            </p>
            <p className="text-base text-gray-800 leading-relaxed mb-1" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1453">
              Sincerely,
            </p>
            <p className="text-base text-gray-800 leading-relaxed mt-4" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-1454">
              Lori Swanson
              <br data-id="element-1455" />
              Secretary
            </p>
          </div>
        </div>
      </div>
    </div>;
}